import CodesManager from "@/components/CodesManager";
import MoodboardUploader from "@/components/MoodboardUploader";
import SeatsManager from "@/components/SeatsManager";
import MarqueeManager from "@/components/MarqueeManager";
import PasscodeManager from "@/components/PasscodeManager";

export default function AdminSitePage() {
  return (
    <section className="container-kynn pt-14 pb-16" data-testid="admin-site-page">
      <div className="small-caps mb-6" style={{ color: "#B9929D" }}>
        Site content — assets, seats, returning-guest codes
      </div>
      <h1
        className="font-display mb-10"
        style={{ fontSize: "clamp(48px, 6vw, 80px)", lineHeight: 1, color: "#F2EEE7", letterSpacing: "-0.02em" }}
      >
        The <em style={{ color: "#DDBFCF" }}>site</em>, curated.
      </h1>

      <MoodboardUploader />
      <MarqueeManager />
      <SeatsManager />
      <CodesManager />
      <PasscodeManager />
    </section>
  );
}
